// Lokalizované texty šablony — česká sada (#327, brána locale od 2026-09-13:
// nový český literál smí vzniknout jen tady, moduly ho importují). Založeno
// s texty velkoobchodní ceny (PR #366); ostatní moduly nesou dluh v baseline
// `tools/unit/fixtures/locale-baseline.json` a stěhují se sem postupně.

import SHOP from '../../../config/shop.js';
import { page } from '../../modules/pages.js';

export const VO = {
  /** popisek nad VO cenou na detailu („Velkoobchodní cena · Jipos Premium") */
  price: 'Velkoobchodní cena',
  /** badge úspory: „−20 % z běžné ceny · ušetříte 578 Kč" */
  fromRetail: 'z běžné ceny',
  save: 'ušetříte',
  /** pásek v rekapitulaci košíku */
  savedWithPricelist: 'Ušetříte s ceníkem ',
  savedGeneric: 'Ušetříte s velkoobchodním ceníkem ',
  /** obecný název, když `priceListId` není v mapě úrovní */
  pricelistGeneric: 'Velkoobchodní ceník',

  // Výprodej: VO cena = cena nepřihlášeného pod běžnou → sleva ceníku se
  // neuplatnila (podlaha marže F34). Texty prošly skillem cestina 2026-09-14.
  /** popisek nad cenou na detailu */
  saleLabel: 'Výprodejová cena',
  /** řádek pod cenou: „Na výprodejovou cenu se sleva ceníku Jipos Premium neuplatní." */
  saleNote: 'Na výprodejovou cenu se sleva ceníku ',
  saleNoteEnd: ' neuplatní.',
  saleNoteGeneric: 'Na výprodejovou cenu se sleva velkoobchodního ceníku neuplatní.',
  /** odkaz za větou (vede na Moje slevy) — stejné znění jako nadpis pravidel */
  saleLink: 'Jak se sleva počítá',
  /** štítek na kartě výpisu: „Výprodej −20 %" */
  saleCardTag: 'Výprodej',

  /** ikona účtu: desktop text „Můj účet / Jipos Premium", aria-label „…, ceník Jipos Premium" */
  account: 'Můj účet',
  accountPricelist: ', ceník ',
  /** mikroštítek u ikony účtu (mobil) a na kartě výpisu */
  tag: 'VO',

  /** Moje slevy: panel cenové hladiny a pravidla pod ním */
  levelValueNote: 'sleva z aktuálních cen',
  rulesTitle: 'Jak se sleva počítá',
  rules: [
    'Sleva se počítá z aktuální ceny zboží, u zboží v akci z akční ceny.',
    'U některého zboží může být sleva nižší, aby cena neklesla pod naši minimální marži.',
    'Na výprodejové ceny se sleva neuplatní.',
  ],
  /** štítek v postranním panelu klientské sekce: „Ceník Jipos Premium" */
  chip: 'Ceník ',
};

// Otevírací doba prodejny × pracovní doba zákaznické podpory (klient 2026-09-15:
// kontaktní bloky nesou podporu, doba prodejny patří jen k prodejně a odběru).
export const HOURS = {
  /** popisek pracovní doby podpory na fotce kontaktu a na 404 */
  support: 'Zákaznická podpora',
  /** krátký popisek v úzké hlavičce mobilní karty „Ozvěte se nám" */
  supportShort: 'Podpora',
  /** stav karty podpory v mobilním menu: v pracovní době / mimo ni */
  supportOnline: 'Právě k dispozici',
  supportOffline: 'Podpora',
  /** nadpis nad bloky otevírací doby na kartě prodejny v kontaktech */
  store: 'Otevírací doba prodejny',
};

// Časté dotazy — /caste-dotazy/. Otázky a odpovědi jsou OBSAH z administrace
// (generuje `tools/ops/faq/sestavit-obsah.mjs`), tady žije jen rám stránky.
export const FAQ = {
  /** adresa stránky (slug administrace `caste-dotazy`) */
  href: page('faq'),
  /** odkaz ve sloupci patičky „Informace pro vás" */
  footerLabel: 'Nejčastěji se ptáte',
  /** odkaz v sekundárním menu topbaru a řádek sekce „Jipos.cz" v mobilním draweru */
  navLabel: 'Časté dotazy',
  /** 4. dlaždice karty „Nejčastější dotazy vyřešíte hned" na /kontakt/ */
  tileTitle: 'Časté dotazy',
  tileSub: 'Odpovědi na jednom místě',
  /** popisek nad H1 */
  eyebrow: 'Časté dotazy',
  /** perex, když ho admin obsah nenese (`p.bs-faq-perex`) */
  perexFallback: 'Odpovědi na to, na co se nás ptáte nejčastěji. Když tu odpověď nenajdete, napište nám.',
  /** primární CTA hera (na /stav-objednavky/) */
  ctaOrder: 'Stav objednávky',
  /** druhé CTA hera, za text se skládá e-mail z CONTACT */
  ctaMail: 'Napsat na ',
  /** aria-label lišty s kotvami na sekce */
  topicsLabel: 'Témata',
  /** nadpis bočního sloupce */
  sideTitle: 'Kam dál',
  /** odkazové karty bočního sloupce (ikony ze sprite.svg) */
  links: [
    { href: page('shipping'), icon: 'truck', title: 'Doprava a platba', desc: 'Ceny, lhůty a způsoby platby' },
    { href: page('terms'), icon: 'file', title: 'Obchodní podmínky', desc: 'Úplné znění lhůt a pravidel' },
    { href: page('claim'), icon: 'shield', title: 'Reklamační formulář', desc: 'Založit reklamaci online' },
    { href: page('withdrawal'), icon: 'refresh', title: 'Vrácení do 14 dnů', desc: 'Odstoupení od smlouvy online' },
  ],
  /** tmavý panel pod odkazy v bočním sloupci */
  helpTitle: 'Nenašli jste odpověď?',
  helpText: 'Napište nám, na které téma odpověď chybí. Odpovíme a doplníme ji i sem.',
  /** CTA pás na konci stránky */
  bandTitle: 'Potřebujete poradit s výběrem?',
  bandText: 'Poradíme s parametry, dostupností i náhradními díly.',
  bandMail: 'Napsat e-mail',
};

// Testovací instance (devInstance.js, incident 2026-09-21) — pruh nahoře a hláška
// místo odeslání objednávky. Kreslí se jen na projektu testovací instance a ne
// pro automatizovaný prohlížeč. Adresa a značka ostré jsou z manifestu shopu.
const LIVE_WEB = SHOP.shop.origin.replace(/^https?:\/\//, '');
export const DEV_NOTICE = {
  barTitle: 'TESTOVACÍ VERZE',
  barText: ' · objednávky odsud k nám nedorazí.',
  barCta: 'Nakupovat na ' + LIVE_WEB + ' →',
  blockTitle: 'Tady objednávku nedokončíte',
  blockText:
    'Jste na testovací verzi e-shopu ' + SHOP.shop.brand + ', objednávka by k nám nedorazila. Stejné zboží najdete na ' + LIVE_WEB + '.',
  blockCta: 'Přejít na ' + LIVE_WEB,
};

// Řádek „Hodí se k tomu" pod položkou košíku (cartCrossSell.js, náhrada doplňku
// „Upsell a cross sell", 2026-09-21). Nadpis sdílí znění s nákupním boxem
// detailu; texty prošly skillem cestina.
export const CART_XSELL = {
  title: 'Hodí se k tomu',
  stock: 'Skladem',
  add: 'Přidat',
  /** aria-label tlačítka: „Přidat do košíku: <název produktu>" */
  addAria: 'Přidat do košíku: ',
};
